export default () => location.reload();
